export { Chip, type ChipProps } from './Chip';
